import { AutoSizer } from 'react-virtualized';
import './autosizer.scss';

export default AutoSizer;
